// Legacy: pro-frontend/src/app/portfolio/portfolio.component.ts mapTemplateIdToType
// Canonical map = public portfolio (shared links). Preview is aligned to this map.

import type { PortfolioTemplateKind } from '../types';

/** Public canonical: 1→modern, 2→creative→architect, 3→classic, 4→minimal */
export function mapTemplateIdToType(templateId: unknown): string {
  const id = Number(templateId);
  if (id === 1) return 'modern';
  if (id === 2) return 'creative';
  if (id === 3) return 'classic';
  if (id === 4) return 'minimal';
  return '';
}

export function mapTemplateType(templateType: string): PortfolioTemplateKind {
  const type = (templateType || '').toLowerCase();
  if (type === 'modern' || type === 'modern_v2') return 'modern';
  if (type === 'classic' || type === 'classic_v2') return 'classic';
  if (type === 'minimal' || type === 'minimal_v2') return 'minimal';
  if (type === 'creative' || type === 'architect' || type === 'double_column_v2') {
    return 'architect';
  }
  return 'architect';
}

export function resolveTemplateKind(
  templateId?: unknown,
  templateType?: string | null,
): PortfolioTemplateKind {
  const fromId = mapTemplateIdToType(templateId);
  if (fromId) {
    return mapTemplateType(fromId);
  }
  if (templateType) {
    return mapTemplateType(templateType);
  }
  return 'architect';
}

/** Reverse map for save API: template kind → numeric template_id */
export function getTemplateIdByKind(kind: string): number {
  const normalized = mapTemplateType(kind);
  if (normalized === 'modern') return 1;
  if (normalized === 'architect') return 2;
  if (normalized === 'classic') return 3;
  if (normalized === 'minimal') return 4;
  return 1;
}

/**
 * Resolve public URL param to API body key.
 * Legacy: isNaN(urlId) → slug, else user_id.
 */
export function resolvePublicPortfolioIdParam(urlId: string): {
  type: 'slug' | 'user_id';
  value: string | number;
} {
  if (Number.isNaN(Number(urlId))) {
    return { type: 'slug', value: urlId };
  }
  return { type: 'user_id', value: parseInt(urlId, 10) };
}
